import { shuffleArray } from '.'

export const numberSorter = (token) => {
  const allNumbers = Array.from({ length: 75 }, (_, i) => i + 1)
  const drawnNumbers = shuffleArray(allNumbers, token)

  return drawnNumbers
}
